module.exports = __webpack_public_path__ + "static/media/recommendations_1.d3173c82.png";